/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
class UserStoreProvider {
  async get(key: string, defaultValue: string): Promise<string> {
    return window.localStorage.getItem(key) || defaultValue;
  }

  async set(key: string, value: string): Promise<void> {
    return window.localStorage.setItem(key, value);
  }

  static browserSupported(): boolean {
    try {
      if (!window.localStorage) {
        return false;
      }

      const name = '__enableability_test__';

      localStorage.setItem(name, 'Evaluating whether local storage is enabled and accessible');
      localStorage.removeItem(name);

      return true;
    } catch (_e) {
      return false;
    }
  }
}

export default UserStoreProvider;